module.exports = __webpack_public_path__ + "img/wuzhentitle.653be0c2.png";